import type { Link } from '@packages/domain/models/link';
import {
  CREATE_PAYMENT_SUCCESS,
  FETCH_PAYMENT_SUCCESS,
  INITIATE_PAYMENT_SUCCESS,
} from 'constants/payment';
import omit from 'lodash/omit';

type LinksAction =
  | {
      type: typeof CREATE_PAYMENT_SUCCESS | typeof FETCH_PAYMENT_SUCCESS;
      payload: {
        entities: {
          links: Record<string, Link>;
        };
      };
    }
  | {
      type: typeof INITIATE_PAYMENT_SUCCESS;
    };

export type LinksState = Record<string, Link>;

const links = (state: LinksState = {}, action: LinksAction) => {
  const newState = { ...state };

  switch (action.type) {
    case CREATE_PAYMENT_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
      const {
        entities: { links = {} },
      } = action.payload;
      return { ...links };
    case INITIATE_PAYMENT_SUCCESS:
      return omit(newState, 'initiate');
    default:
      return state;
  }
};

export { links };
